<template>
    <div
        class="modal h-full"
        v-if="showEditProgramModal"
        aria-labelledby="edit-program-modal"
        role="dialog"
        aria-modal="true"
    >
        <div class="modal-overlay" aria-hidden="true"></div>
        <div
            class="inner shadow"
            style="-webkit-transform: translate3d(0, 0, 0)"
        >
            <a
                href="#"
                class="modal-close-btn"
                role="button"
                @click.prevent="closeModal()"
            >
                <i class="fal fa-times"></i>
            </a>
            <header
                class="modal-header items-start p-2 bg-white border-t-4 border-solid border-t-orange rounded-t-lg"
            ></header>

            <div class="modal-body items-start">
                <div class="steps">
                    <div class="step">
                        <img
                            :src="`${cdnUrl}/${reward.program_image?.path}/_small/${reward.program_image?.file_name}`"
                            :alt="reward.name"
                            class="mb-8 mx-auto"
                            style="max-height: 100px; max-width: 175px"
                        />
                        <div
                            v-if="
                                (reward.connected &&
                                    reward.program_user.rewards_source ===
                                        'manual') ||
                                !reward.connected
                            "
                            class="text-center"
                        >
                            <h4 class="text-lg lg:text-2xl text-center mb-8">
                                Update Your {{ reward.name }} Points Balance
                            </h4>

                            <div
                                class="mt-6 mb-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6 justify-items-center justify-center"
                            >
                                <div class="sm:col-span-2 sm:col-start-2 mb-3">
                                    <UiInput
                                        id="rewards-points"
                                        name="rewards-points"
                                        label="Number of Points"
                                        placeholder="XXX,XXX..."
                                        class="w-full"
                                    >
                                        <template #input>
                                            <VueNumberFormat
                                                class="relative block w-full rounded border border-slate-200 bg-white py-1.5 text-gray-900 placeholder:text-gray-400 focus:z-10 placeholder:text-sm focus:ring-0 active:ring-0 focus:border-slate-800 active:border-slate-800"
                                                v-model:value="reward.points"
                                                placeholder="XXX,XXX..."
                                                step="1"
                                            ></VueNumberFormat>
                                        </template>
                                    </UiInput>
                                </div>

                                <div class="sm:col-span-2">
                                    <UiInput
                                        id="balance-date"
                                        name="balance-date"
                                        label="Date"
                                        placeholder="Select Date ..."
                                        :options="{
                                            icon: 'calendar',
                                        }"
                                        class="w-full"
                                    >
                                        <template #input>
                                            <flat-pickr
                                                :config="dateConfig"
                                                class="relative block w-full rounded border border-slate-200 bg-white py-1.5 pl-10 text-gray-900 placeholder:text-gray-400 focus:z-10 placeholder:text-sm focus:ring-0 active:ring-0 focus:border-slate-800 active:border-slate-800"
                                                v-model="balanceDate"
                                            ></flat-pickr>
                                        </template>
                                    </UiInput>
                                </div>
                            </div>
                            <div class="h-12">
                                <Transition name="fade">
                                    <Errors :errors="errors" />
                                </Transition>
                            </div>
                        </div>
                        <!--
                        <div class="text-center" v-if="reward.type !== 'flexible_currency'">
                            <h4 class="text-sm font-medium text-gray-700 text-center mb-1">
                                Do You Have Elite Status With {{ reward.name }}?
                            </h4>
                            <select
                                class="form-select mx-auto max-w-md mb-5"
                                v-model="hasEliteStatus"
                            >
                                <option value=""></option>
                                <option value="Y">Yes</option>
                                <option value="N">No</option>
                            </select>
                            <div class="flex flex-col" v-if="hasEliteStatus === 'Y'">
                                <h4 class="text-sm font-medium text-gray-700 text-center mb-1">
                                    What Elite Status Do You Have?
                                </h4>
                                <select class="form-select mx-auto max-w-md" v-model="eliteStatus">
                                    <option value=""></option>
                                    <option
                                        v-for="(level, levelIndex) in reward.levels"
                                        :value="level.title"
                                        :key="'level-' + levelIndex"
                                    >
                                        {{ reward.name }} {{ level.title }}
                                    </option>
                                </select>
                            </div>
                        </div>-->
                    </div>
                </div>
            </div>

            <footer
                class="modal-footer flex !flex-row justify-between items-center bg-gray-50"
            >
                <button
                    type="button"
                    class="btn btn-secondary !w-24 md:!w-48 !bg-gray-50"
                    @click.prevent="closeModal()"
                >
                    Close
                </button>
                <ActionButton
                    @clicked="editReward"
                    :label="actionBtnLabel"
                    :loading="saveProgramBtnAction"
                    classes="btn btn-primary !w-48"
                />
            </footer>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from 'pinia';
import { usePointsStore } from '@/store/points';
import dayjs from 'dayjs';

import ActionButton from '@/components/action-button.vue';
import FlatPickr from 'vue-flatpickr-component';
import Errors from '@/components/errors.vue';
import UiInput from '@/components/ui/inputs/ui-input.vue';
import { toDisplayString } from 'vue';

export default {
    components: {
        ActionButton,
        FlatPickr,
        Errors,
        UiInput,
    },
    data: () => ({
        errors: [],
        saveProgramBtnAction: false,
        balanceDate: dayjs().toDate(),
        dateConfig: {
            dateFormat: 'm/d/Y',
            defaultDate: dayjs().toDate(),
            maxDate: dayjs().toDate(),
        },
    }),
    watch: {},
    computed: {
        ...mapState(usePointsStore, [
            'programs',
            'reward',
            'user',
            'addRewardUser',
            'showProgramModal',
            'showEditProgramModal',
        ]),
        cdnUrl() {
            return window.cdnUrl;
        },
        actionBtnLabel() {
            return this.reward.connected &&
                !this.reward.program_user.rewards_srouce === 'manual'
                ? 'Update'
                : 'Update Balance';
        },
        hasEliteStatus: {
            get() {
                return this.reward.program_user
                    ? this.reward.program_user.has_elite_status
                    : null;
            },
            set(value) {
                if (this.reward.program_user === null) {
                    this.reward.program_user = {
                        has_elite_status: null,
                        elite_status: null,
                        id: null,
                    };
                }
                this.reward.program_user.has_elite_status = value;
            },
        },
        eliteStatus: {
            get() {
                return this.reward.program_user
                    ? this.reward.program_user.elite_status
                    : null;
            },
            set(value) {
                if (this.reward.program_user === null) {
                    this.reward.program_user = {
                        has_elite_status: null,
                        elite_status: null,
                        id: null,
                    };
                }
                this.reward.program_user.elite_status = value;
            },
        },
    },
    methods: {
        ...mapActions(usePointsStore, [
            'getRewards',
            'deleteProgram',
            'editProgram',
            'setProgramModal',
            'setEditProgramModal',
            'showProgramModalAction',
        ]),
        editReward() {
            this.validateStep();
            if (this.errors.length === 0) {
                this.saveProgramBtnAction = true;
                if (!this.reward.connected) {
                    this.reward.balance_date = this.balanceDate;
                }

                if (
                    this.reward.connected &&
                    !this.reward.program_user.rewards_source === 'manual'
                ) {
                    this.postProgram();
                } else {
                    this.putRewards();
                }
            }
        },
        putRewards() {
            this.reward.has_elite_status = this.hasEliteStatus;
            this.reward.elite_status = this.eliteStatus;
            this.reward.user_id = this.user.id;
            this.reward.user = { id: this.user.id };
            this.reward.program_id = this.reward.manual_reward_id
                ? this.reward.program_id
                : this.reward.program_user.program_id;
            const method = this.reward.manual_reward_id ? 'put' : 'post';
            const id = this.reward.manual_reward_id
                ? this.reward.manual_reward_id
                : null;
            const path = this.reward.manual_reward_id
                ? '/rewards/' + id
                : '/rewards';
            ApiService.apiCall(path, method, this.reward)
                .then(() => {
                    if (import.meta.env.VITE_APP_ENV === 'production') {
                        woopra.track('program-updated-my10x', {
                            program: this.reward.name,
                            balance: this.reward.points,
                            uuid: localStorage.getItem('uuid'),
                        });
                    }
                    setTimeout(() => {
                        this.saveProgramBtnAction = false;
                        this.closeModal();
                        this.balanceDate = new Date();
                    }, 500);
                })
                .catch((error) => {
                    this.$root.handleHttpStatus(error);
                    this.saveProgramBtnAction = false;
                });
        },
        postProgram() {
            let method = this.reward.program_user.id ? 'put' : 'post';
            let id = this.reward.program_user.id
                ? this.reward.program_user.id
                : this.reward.id;
            this.reward.has_elite_status = this.hasEliteStatus;
            this.reward.elite_status = this.eliteStatus;
            this.reward.user_id = this.user.id;
            ApiService.apiCall('/program-user/' + id, method, this.reward)
                .then(() => {
                    setTimeout(() => {
                        this.saveProgramBtnAction = false;
                        this.$emit('close');
                    }, 500);
                })
                .catch((error) => {
                    this.$root.handleHttpStatus(error);
                    this.saveProgramBtnAction = false;
                });
        },
        validateStep() {
            this.errors = [];
            if (this.reward.points === '' && !this.reward.connected) {
                this.errors.push({
                    message: 'Please enter your reward points.',
                });
            }
            if (
                (this.balanceDate === '' || !this.balanceDate) &&
                !this.reward.connected
            ) {
                this.errors.push({ message: 'Please enter your points date.' });
            }
            if (
                this.hasEliteStatus &&
                this.hasEliteStatus === 'Y' &&
                !this.eliteDtatus
            ) {
                //this.errors.push({ message: 'Please enter your elite status.' });
            }
        },
        closeModal() {
            this.errors = [];
            this.getRewards();
            this.setEditProgramModal(false);
        },
    },
    created() {},
    mounted() {},
};
</script>
<style lang="scss" scoped>
.steps {
    position: relative;
    height: 100%;
}
.step {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
